<!--
/*
 * @Description: 使用手机号 快速登录注册
 * @Author: Guojun
 * @Date: 2020-05-19 14:43:48
 * @LastEditTime: 2020-5-20 09:02:47
 */
  -->
<template>
  <div class="phoneLogin">
    <p class="phoneHint">使用手机验证码快速登录，无账号将自动注册</p>
    <el-form ref="pohneLogin" :model="pohneLogin" :rules="rules">
      <div style="display:flex;">
        <el-form-item class="phoneCode-item">
          <el-select v-model="area" placeholder="请选择">
            <el-option label="+86" value="86"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="phone" class="phoneCode-item">
          <el-input
            placeholder="请输入手机号"
            v-model="pohneLogin.phone"
            class="input-with-select"
            maxlength="11"
            @keyup.enter.native="login()"
            clearable
          ></el-input>
        </el-form-item>
      </div>
      <el-form-item prop="phoneCode" class="phoneCode-item" style="height:50px">
        <el-input
          placeholder="请输入短信验证码"
          v-model="pohneLogin.phoneCode"
          maxlength="6"
          class="phoneCode"
          @keyup.enter.native="login()"
        ></el-input>
        <p class="getYzCode" @click="getCode">
          <span v-if="sendMsgDisabled">{{ code_text }}</span>
          <span v-if="!sendMsgDisabled">{{this.second}} s</span>
        </p>
      </el-form-item>
      <el-form-item class="btn">
        <p
          style="position: absolute;top:-8px; font-size:12px;color:#fabe00;"
          v-if="isGetCode"
        >短信已发送,请注意查收</p>
        <el-button @click.prevent="login()" class="loginBtn">登录</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import Vue from "vue";
import user from "../apis/user_apis";
import utils from "../utils/utils";
import { phoneLoginRules } from "../validate/rules";
export default {
  data() {
    return {
      show: false,
      pohneLogin: {
        phone: "",
        phoneCode: "",
      },
      area: "+86",
      rules: phoneLoginRules,
      isGetCode: false,
      second: 60,
      req_time: "",
      sendMsgDisabled: true,
      code_text: "获取验证码",
      captcha: "", //行为验证码
    };
  },
  props: {},
  created() {
    //   this.$EventBus.$on("verfySuccess", (data) => {
    //   console.log("监测success");
    //   this.captcha = data;
    //   console.log(data)
    //   this.getMessageCode();
    // });   
  },
  mounted(){
    this.$EventBus.$on("verfySuccess", (data) => {
      console.log("监测success");
      this.captcha = data;
      console.log(data)
      this.getMessageCode();
    });   
  },
  beforeDestroy(){
    this.$EventBus.$off('verfySuccess')
  },
  methods: {
    // 登录
    login() {
      let that = this;
      this.$refs.pohneLogin.validate((valid) => {
        if (valid) {
          user.slideLogin(that).then((res) => {
            if (res.success) {
              let account = {
                name: res.data.userName,
              };
              utils.setCookie("TOKEN", res.data.token);
              utils.setCookie("USER_INFO",res.data.mobile);
              this.$store.commit("USER_INFO", res.data.mobile);
              this.show = false;
              if (res.data.state ===0) {
               this.$EventBus.$emit('firstLogin',true)
              } else {
                this.$router.push({
                  path: "/index",
                });
                window.location.reload();
              }
            } else {
            }
          });
        } else {
          return false;
        }
      });
    },
    //点击获取手机验证码
    getCode() {
      let that = this;
      this.$refs.pohneLogin.validateField("phone", (valid) => {
        if (!valid) {
          if (that.sendMsgDisabled) {
            that.$EventBus.$emit("slideShow", true);
          } else {
            return;
          }
        } else {
          return false;
        }
      });
    },
    // 获取短信验证码
    getMessageCode() {
      const query = {
        mobile:this.pohneLogin.phone,
        captcha:this.captcha,
        smsType:'login',
      }
      user.sendsmscode(query).then((res) => {
        if (res.success) {
          this.sendMsgDisabled = false;
          this.$message({
            message: "验证码10分钟有效",
            type: "success",
          });
          this.isGetCode = true;
          this.timer = setInterval(() => {
            this.second--;
            if (this.second <= 0) {
              clearTimeout(this.timer);
              this.sendMsgDisabled = true;
              this.second = 60;
              this.code_text = "重新获取";
            }
          }, 1000);
        }
      });
    },
    throttle(fn, wait) {
      let timer;
      return function () {
        if (!timer) {
          timer = setTimeout(() => {
            timer = null;
            fn.apply(this, arguments);
          }, wait);
        }
      };
    },
  },
};
</script>
 
<style lang="less" scoped>
.phoneLogin {
  .phoneHint {
    position: relative;
    top: -30px;
    font-size: 14px;
  }
  .phoneCode-item {
    /deep/.el-form-item__content {
      display: flex;
    }
  }
  .el-form-item {
    height: 60px;
    margin-bottom: 0px !important;
    position: relative;
    /deep/ .el-select {
      width: 100px;
    }
    .getYzCode {
      position: absolute;
      right: 0;
      top: 0;
      bottom: 8px;
      display: inline-block;
      width: 80px;
      height: 36px;
      line-height: 36px;
      font-size: 12px;
      text-align: center;
      color: #fff;
      background: rgba(250, 190, 0, 1);
      border: 1px solid rgba(250, 190, 0, 1);
      border-radius: 2px;
      cursor: pointer;
    }
    .phoneCode {
      /deep/ .el-input__inner {
        width: 200px;
      }
    }
    .btn {
      margin-top: 20px;
      height: auto;

      /deep/ .el-form-item__content {
        margin-left: 0 !important;
      }
    }

    /deep/ .el-button + .el-button {
      margin-left: 30px !important;
    }
    /deep/ .el-button {
      padding: 0;
      width: 300px;
      height: 41px;
      margin-top: 30px;
      font-size: 14px;
      border: 1px solid rgba(250, 217, 0, 1);
      color: #fff;
      font-weight: normal;
      border-radius: 2px;
      background: linear-gradient(
        90deg,
        rgba(250, 217, 0, 1) 0%,
        rgba(250, 190, 0, 1) 100%
      );
      box-shadow: 0px 3px 12px rgba(250, 190, 0, 0.5);
    }
    /deep/ .el-button:hover {
      color: #fff;
      background: rgba(252, 111, 25, 1);
      box-shadow: 0px 3px 12px rgba(250, 108, 0, 0.3);
    }
    /deep/ .el-checkbox__inner {
      border: 1px solid #808495;
    }
    /deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
      border: 1px solid #dcdfe6;
    }
    /deep/ .el-input__inner:focus {
      // caret-color: #fabe00;
      border-color: #333;
    }
  }
}
</style>